// Location tracking disabled for privacy and security
// This component is now a no-op to prevent invasive tracking
export const LocationTracker = () => {
  // Location tracking has been disabled due to security concerns
  // Future implementation should be opt-in with explicit user consent
  return null;
};